import { createField } from "./inspection-info.section";
import lodash from "lodash";

export const initForm = ({ props, data, refs }) => {
    const key = props.dataKey;
    const isLoading = props.isLoading;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    data.fields = createField({ props, data, refs, key, isLoading });
    if (model?.id) {
        data.mainSubStance = {
            fetchCriteria: {
                select: ["**", "refSubStance.**"],
                page: 0,
                size: 1000000,
                where: [{ name: "refInspection.id", type: "UUID", operator: "=", value: model.id }],
                sort: [{ name: "createDate", type: "ASC" }],
                children: [
                    {
                        name: "companies",
                        select: [
                            "*",
                            "refUserCompany.id",
                            "refUserCompany.version",
                            "refUserCompany.companyNameTh",
                            "refUserCompany.companyNameEn",
                            "refUserCompany.fullNameTh",
                            "refUserCompany.fullNameEn",
                            "refUserCompany.refPersonType.*"
                        ],
                        page: 0,
                        size: 1000000,
                        children: [
                            {
                                name: "refUserCompany.inspections",
                                select: ["id", "version", "approveCode", "refUserCompany.id", "refUserCompany.version"],
                                page: 0,
                                size: 1000000,
                                where: [
                                    { name: "isActive", type: "Boolean", operator: "=", value: true },
                                    { name: "isTemp", type: "Boolean", operator: "=", value: false },
                                    { name: "refStatus.key", type: "String", operator: "!=", value: "cancel" }
                                ]
                            }
                        ]
                    },
                    {
                        name: "products",
                        select: [
                            "*",
                            "refInspection.id",
                            "refInspection.version",
                            "refInspection.approveCode",
                            "refInspection.refUserCompany.id",
                            "refInspection.refUserCompany.version"
                        ],
                        page: 0,
                        size: 1000000
                    },
                    { name: "attachments", select: ["*"], page: 0, size: 1000000 }
                ]
            }
        };
    }
};
